module.exports = __webpack_public_path__ + "024ddde603b08933d1582e9954c38e40.svg";